import { applyMixins } from '@fry/lib/utils/mixin';

import { IsInheritable } from '../is-inheritable/is-inheritable.model';


export class EditorBookingItemMetadata {
  name: string;
  value: string;

  constructor(obj?: any) {
    this.name = obj?.name ?? null;
    this.value = obj?.value ?? null;
    this.inheritableType = obj?.inheritableType ?? null;
  }

  createCopy(): EditorBookingItemMetadata {
    return new EditorBookingItemMetadata({
      name: this.name,
      value: this.value,
      inheritableType: this.inheritableType
    });
  }

  createChild(): EditorBookingItemMetadata {
    const metadata = this.createCopy();
    metadata.inheritableType = metadata.getClonedInheritableTypeAsChild();
    return metadata;
  }

  createComplete(parent: EditorBookingItemMetadata): EditorBookingItemMetadata {
    const metadata = this.createCopy();
    metadata.inheritableType = parent.getUserDefinedInheritableTypeAsChild(metadata.inheritableType);
    return metadata;
  }
}

// tslint:disable-next-line:no-empty-interface
export interface EditorBookingItemMetadata extends IsInheritable {}
applyMixins(EditorBookingItemMetadata, [IsInheritable]);
